<template>
    <v-row>
        <v-col cols="12" sm="6" md="6"  v-if="reasignacion">
            <AutocompleteComp v-model='coord.id_estado_reasignacion' :items="Estados" item-text="desc_estado" item-value="id"
                textLabel="Motivo de reasignación"/>
        </v-col>

        <v-col cols="12" class="pb-0">
            <div class="docente-seleccionado">
                <h2>{{ coord.nombre_persona }}</h2>
                <v-avatar color="purple" class="avatar-profesor">
                    <span v-if="inicial" class="white--text headline">{{ inicial }}</span>
                    <v-icon v-else dark > mdi-account-circle</v-icon>
                </v-avatar>
            </div>
        </v-col>

        <v-col cols="12">
            <v-card>
                <ComundataTablecomp :headers="profesoresHeaders" :items="Profesores" whitSearch :search="search" noResultsText="Sin coordinadores disponibles">
                    <template v-slot:accion="{ item }">
                        <TableButtonComp @click="asignarDocente(item)" textButton="Asignar" iconBut="fas fa-plus"/>
                    </template>
                </ComundataTablecomp>
            </v-card>

        </v-col>


        <v-col cols="12">
            <v-divider></v-divider>
        </v-col>



        <v-col cols="12" md="6" sm="6" v-if="datosAgregar">
            <v-chip class="primary">Tipo de responsable:</v-chip>

            <v-radio-group :mandatory="false" v-model='coord.tipo'>
                <v-radio v-for="item of opciones" :key="item.id" :label="item.label" :color="item.color"
                    :value="item.value"></v-radio>
            </v-radio-group>
        </v-col>


        <v-col cols="12" md="6" sm="6" v-if="datosAgregar">
            <v-textarea v-model='observacion' outlined name="input-7-4" label="Observación"></v-textarea>
        </v-col>

        <v-col cols="12">
            <v-divider></v-divider>
        </v-col>

        <v-col cols="12" class="text-right" v-if="datosAgregar">
            <TableButtonComp @click="asignar(coord.id_coord)" iconBut="fas fa-save" normalButton textButton="Guardar"/>
        </v-col>
    </v-row>
</template>



<script>
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import TableButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import { profesoresHeaders } from '../../../../helpers/headersTable';
import axios from "../../../../helpers/axios";

export default {
    components:{
        ComundataTablecomp,
        TableButtonComp,
        AutocompleteComp

    },
    name: 'responsable',
    props: ['reasignacion', 'coord', 'tipo'],

    data: () => ({
        profesoresHeaders,
        search: '',
        datosAgregar: false,
        opcion: null,
        inicial: '',
        observacion: '',


        Profesores: [],
        Estados: [],

      

        opciones: [
            { label: "ENCARGADO", color: "info", value: 1 },
            { label: "SUPLENTE", color: "info", value: 0 },
        ],
    }),


    mounted() {
        this.getAllProfesores()
        this.getAllEstados()
    },


    methods: {
        /********funciones emit */
        asignar(id) {
            if (this.tipo === 1 && this.observacion != '') {
                this.coord.observacion_asignacion = this.observacion
            } else if (this.tipo === 2 && this.observacion != '') {
                this.coord.observacion_reasignacion = this.observacion
                this.coord.id_estado = 1
            }
            console.log('aquiiii-------->>>' + JSON.stringify(this.coord))
            this.$emit('asignacion', id)
        },


        /************traer profesores del colegio ********/
        async getAllProfesores() {
            //id del colegio
            var id = sessionStorage.id_colegio
            let id_anio_lectivo = sessionStorage.id_ano_lectivo
            try {
                let response = await axios.get("/administrativo/coordinacion/all/pdc/" + id + "/anio_lectivo/" + id_anio_lectivo);
                this.Profesores = response.data;
                console.log(JSON.stringify(this.Profesores))
            }
            catch (error) {
                console.log(error);
            }
        },


        //*********cargar estados parta asociar a responsable */
        async getAllEstados() {
            try {
                const response = await axios.get("/administrativo/coordinacion/all/stc/");
                this.Estados = response.data
                console.log(response.data)
            } catch (error) {
                console.log(error)
            }
        },


        //-------------asignar docente -----------
        asignarDocente(item) {
            var letra = item.nombre_apellido.charAt(0);
            this.inicial = letra.toUpperCase();
            this.coord.id_personal = item.id
            this.coord.nombre_persona = item.nombre_apellido
            this.coord.id_tipo_documento = item.id_tipo_documento
            this.coord.numdoc_persona = item.numdoc_persona
            if (this.tipo === 1) {
                this.coord.aux = 1
            } else if (this.tipo === 2) {
                this.coord.aux = 3
            }
            this.datosAgregar = true
        }
    }
}
</script>


<style scoped>
.docente-seleccionado {
    width: 100%;
    background: #E6E6E6;
    height: 62px;
    border-left: 6px solid #045FB4;
    border-right: 6px solid #045FB4;
    padding-top: 21px;
    position: relative;
}

.docente-seleccionado h2 {
    color: #045FB4;
    text-transform: uppercase;
    text-align: center;
}

.docente-seleccionado .avatar-profesor {
    position: absolute;
    top: 7px;
    left: 16px;
}

@media(max-width: 425px) {
    .docente-seleccionado .avatar-profesor {
        display: none;
    }
}
</style>